import { Component } from 'react';
import { withRouter } from '../../utils/withRouter';

class ScrollToTop extends Component<any> {
  componentDidUpdate(prevProps: any) {
    const prevLocation = prevProps.router ? prevProps.router.location : prevProps.location;
    const currentLocation = this.props.router ? this.props.router.location : this.props.location;
    if (currentLocation && prevLocation && currentLocation.pathname !== prevLocation.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(ScrollToTop);
